// Inicia o contador (Barra superior checkout)
let countdown;
function initCountdown() {
  const $countdownEl = $('.countdown-checkout');
  const mode = $countdownEl.data('mode');
  const minutes = $countdownEl.data('minutes');
  const date = $countdownEl.data('date');
  let futureDate;
  if (mode === 'date') {
    futureDate = new Date(date);
  } else if (mode === 'minutes') {
    futureDate = new Date();
    futureDate.setMinutes(new Date().getMinutes() + Number(minutes));
  }
  if (countdown) {
    countdown.destroy();
  }
  if ($countdownEl.length > 0) {
    countdown = new Countdown(futureDate);
  }
}
initCountdown();

// Inicia o contador do Pix
if ($('.countdown-pix').length > 0) {
  let countdownPix;
  function formatDateTimeIOS(dateStr) {
    return dateStr.replace(/\s/, 'T');
  }
  function initCountdownPix() {
    let futureDate;
    const $countdownEl = $('.countdown-pix');
    const mode = $countdownEl.data('mode');
    const minutes = $countdownEl.data('minutes');
    let date = $countdownEl.data('date');
    if (mode === 'date') {
      date = formatDateTimeIOS(date);
      futureDate = new Date(date);
    } else if (mode === 'minutes') {
      futureDate = new Date();
      futureDate.setMinutes(new Date().getMinutes() + Number(minutes));
    }
    if (countdown) {
      countdownPix.destroy();
    }
    if ($countdownEl.length > 0) {
      countdownPix = new Countdown(futureDate, function () {
        window.location.reload();
      });
    }
  }
  initCountdownPix();
}
